import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { theme } from "../../../../helpers/theme";
import { Services } from "../../../../services/warehouses/services-get-by-id/types";
import { getAllWarehouseServicesGetById } from "../../../../services/warehouses/services-get-by-id";
import { LoadingBackDrop } from "../../../../components/loader";
import { StyledTable } from "../../../../components/table/styled-table";
import { GoBackButton } from "../../../../components/GoBackButton";

const WarehousesServices = () => {
  const { id } = useParams();

  const [subcontractorEdited, setSubcontractorEdited] = useState({
    id: "",
    usluga: "",
    typ_uslugi: "",
    aktywny: false,
    wymaga_wyceny: false,
    info_dodatkowe: "",
  });

  const columns: GridColDef[] = [
    {
      field: "usluga",
      headerName: "Usługa",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
    },
    {
      field: "typ_uslugi",
      headerName: "Typ",
      width: 200,
    },
    {
      field: "czy_aktywna",
      headerName: "Aktywna",
      width: 150,
    },
    {
      field: "czy_wymaga_wyceny",
      headerName: "Wymaga wyceny",
      width: 150,
    },
    {
      field: "info_dodatkowe",
      headerName: "Uwagi",
      width: 300,
    },
  ];

  const [services, setServices] = useState<Services[]>([]);

  const body = {
    id_magazyn: String(id),
  };

  const GetAllWarehouseServicesGetById = useQuery(
    ["Services"],
    () => getAllWarehouseServicesGetById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setServices(data.data.payload.uslugi_magazynu);
      },
    }
  );

  const getServiceFromEnum = (purpose: number) => {
    switch (purpose) {
      case 0:
        return "Składowanie";
      case 1:
        return "Cross-docking";
      case 2:
        return "Fullfilment";
      case 3:
        return "Etykietowanie";
      case 4:
        return "Pakowanie";
      case 5:
        return "Sortowanie";
      case 6:
        return "E-commerce";
      case 7:
        return "Wysyłka";
      case 8:
        return "Inne";
      case 9:
        return "Przyjęcie Towaru";
      case 10:
        return "Wydanie Towaru";
    }
  };

  const getTypeFromEnum = (type: number) => {
    switch (type) {
      case 0:
        return "Główna";
      case 1:
        return "Dodana";
      case 2:
        return "Dodatkowa";
    }
  };

  // const dateFormating = (date: Date) => {
  //   const dateSeconds = Date.parse(date.toString());
  //   const dateObject = new Date(dateSeconds);
  //   return dateObject.toLocaleDateString("pl-PL");
  // };

  const rows = services.map((r: Services) => ({
    id: r.id_uslugi_magazynow,
    usluga: getServiceFromEnum(r.usluga),
    typ_uslugi: getTypeFromEnum(r.typ_uslugi),
    czy_aktywna: r.czy_aktywna ? "Tak" : "Nie",
    czy_wymaga_wyceny: r.czy_wymaga_wyceny ? "Tak" : "Nie",
    info_dodatkowe: r.info_dodatkowe,
  }));

  if (
    GetAllWarehouseServicesGetById.isLoading ||
    GetAllWarehouseServicesGetById.isRefetching
  ) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <>
      <ServicesContainer>
        <ViewNavigation>
          <Redirect>
            <GoBackButton description={"Powrót"} />
          </Redirect>
        </ViewNavigation>
        <StyledTable
          // getRowId={(row) => row?.id}
          rows={rows}
          columns={columns}
          autoPageSize
          //autoHeight={true}
        />
      </ServicesContainer>
    </>
  );
};

export default WarehousesServices;

const ServicesContainer = styled.div`
  height: 80vh;

  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
const ViewNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 340px) {
    flex-direction: column;
  }
`;

const Redirect = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;
